<template>
  <div class="form-card">
    <div class="title" v-html="formattedTitle"></div>
    <div
      class="btn"
      :class="{ 'btn-disabled': isLoginCardDisabled }"
      @click="handleClick"
    >
      <span>{{ btnText }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(["userInfo", "defaultRoleInfo"]),
    formattedTitle() {
      const text = this.data.tips || "";
      if (text.includes("点击下方按钮")) {
        // 全局替换，确保所有出现的“点击下方按钮”都被加粗
        return text.replace(
          /点击下方按钮/g,
          '<span style="font-weight: bold;">点击下方按钮</span>',
        );
      }
      return text;
    },
    isLoggedIn() {
      return Boolean(
        localStorage.getItem("token") && this.userInfo && this.userInfo.id,
      );
    },
    isNeedBindRole() {
      return Boolean(
        !this.defaultRoleInfo ||
          !this.defaultRoleInfo.id ||
          this.defaultRoleInfo.id === "tourist" ||
          this.defaultRoleInfo.is_guest === 1,
      );
    },
    isLoginCardNeedBindRole() {
      return (
        this.data.card_name === "登录账号" &&
        this.isLoggedIn &&
        this.isNeedBindRole
      );
    },
    isLoginCardNeedLogin() {
      return this.data.card_name === "登录账号" && !this.isLoggedIn;
    },
    isLoginCardDisabled() {
      return (
        this.data.card_name === "登录账号" &&
        this.isLoggedIn &&
        !this.isNeedBindRole
      );
    },
    btnText() {
      if (this.data.name === "提交反馈") {
        return "点击此处提交问题";
      }
      if (this.isLoginCardNeedBindRole) {
        return "绑定角色";
      }
      if (this.isLoginCardDisabled) {
        return "已登录";
      }
      return this.data.card_name;
    },
  },
  methods: {
    ...mapActions(["checkLogin"]),
    saveMessageId(type) {
      if (this.data.message_id) {
        sessionStorage.setItem(
          "ai_message_info",
          JSON.stringify({
            message_id: this.data.message_id,
            type,
          }),
        );
      }
    },
    handleClick() {
      if (this.isLoginCardDisabled) {
        return;
      }
      if (this.isLoginCardNeedLogin) {
        this.saveMessageId("login");
        this.$eventBus.$emit("showLogin");
        return;
      }
      if (this.isLoginCardNeedBindRole) {
        this.saveMessageId("bind_role");
        this.$router.push({
          name: "BindRoles",
        });
        return;
      }
      if (this.data.card_name === "人工客服") {
        this.checkLogin()
          .then(() => {
            if (this.isNeedBindRole) {
              this.saveMessageId("bind_role");
              this.$router.push({
                name: "BindRoles",
              });
              return;
            }
            this.$emit("imChat");
          })
          .catch((err) => {
            this.saveMessageId("login");
            this.$eventBus.$emit("showLogin");
          });
      }
      if (this.data.url) {
        this.checkLogin()
          .then(() => {
            const session_id = sessionStorage.getItem("im_sess_uuid");
            let url = this.data.url;
            if (session_id) {
              if (url.indexOf("?") === -1) {
                url += "?session_id=" + session_id;
              } else {
                url += "&session_id=" + session_id;
              }
            }
            window.open(url);
          })
          .catch((err) => {
            this.$eventBus.$emit("showLogin");
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.form-card {
  margin: 7.5px 0;
  padding: 12px;
  background: #ffffff;
  border-radius: 0px 10px 10px 10px;
  .title {
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 32px;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    background-color: @gold;
  }
  .btn-disabled {
    background-color: #c0c4cc;
    color: #ffffff;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
